import { FormattedRpServiceConfigurationAttribute } from "@idw-types/data/rp-service-configuration";
import { SelectOption } from "@iddataweb/idw-common-ui/types";
import { AXNUISelectInput } from "@iddataweb/idw-common-ui/containers";
import commonStyles from "@styles/common.less";
import { AXNUIThemingLabelComponent } from "@containers/common/axnui-theming-preview-container/axnui-theming-label-component/axnui-theming-label-component";

type AXNUIThemingSelectInputComponentProps = {
    attribute: FormattedRpServiceConfigurationAttribute;
    isRequired: boolean;
    label: string;
    placeholder: string;
    options?: Array<SelectOption>;
};

export const AXNUIThemingSelectInputComponent = (props: AXNUIThemingSelectInputComponentProps) => {
    const { attribute, isRequired, label, placeholder, options = [] } = props;

    return (
        <div className={commonStyles.axnuiPreviewInputContainer}>
            <AXNUIThemingLabelComponent
                controlId={`attribute-input-${attribute.attributeType.id}`}
                label={label}
                isRequired={isRequired}
            />

            <AXNUISelectInput
                controlId={attribute.attributeType.name}
                automationId={attribute.attributeType.name}
                required={isRequired}
                disabled={false}
                readOnly={true}
                ariaLabel={label}
                placeholder={placeholder}
                selectedOption={null}
                title={null}
                onChange={() => { }}
                options={options}
                isSearchable={false}
                isClearable={false}
            />
        </div>
    );
};
